import { template as template_54a45f0a39ea4d52b2dba2a72f88d2eb } from "@ember/template-compiler";
import PendingInsuranceInfoBanner from './pending-insurance-info-banner';
import RejectedRequests from './rejected-requests';
import styles from './submission-notifications.module.scss';
export default template_54a45f0a39ea4d52b2dba2a72f88d2eb(`
  <div class={{styles.component}}>
    {{#if @pendingInsuranceRequests}}
      <PendingInsuranceInfoBanner @pendingInsuranceInfoCount={{@pendingInsuranceRequests.length}} />
    {{/if}}
    {{#if @rejectedInsuranceRequests}}
      <RejectedRequests @rejectedInsuranceRequests={{@rejectedInsuranceRequests}} />
    {{/if}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
